export function getCustomerHappinessIndexEndpoint(): string {
    return '/customer-happiness-index';
}
